module.exports = __webpack_public_path__ + "assets/img/phone.43d65664.png";